// extracted by mini-css-extract-plugin
module.exports = {"yogaNutritionBootcampPage":"YogaNutritionBootcampPage_yogaNutritionBootcampPage__Eqqjl","certifiedInstructors":"YogaNutritionBootcampPage_certifiedInstructors__n7Wlm"};